import 'css-chunksrc/client/scenes/eventCreation/styles.scss';export default {
  "eventCreation": "_eventCreation_t8kkt_1",
  "main": "_main_t8kkt_7",
  "buttons": "_buttons_t8kkt_21"
};